import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightsmodal'
})
export class HighlightsmodalPipe implements PipeTransform {

  constructor() { }

  transform(text: any, term: string): any {
    if (!term) {
      const excerpt = text.substring(0, 300);
      return excerpt + "...";
    }

    const cleanText = this.removeAccents(text); // Remover acentos
    const cleanTerm = this.removeAccents(term);

    const termPosition = cleanText.toLowerCase().indexOf(cleanTerm.toLowerCase());

    if (termPosition === -1) {
      const excerpt = text.substring(0, 300);
      return excerpt + "...";
    }

    const sizeText = text.length;
    const posInitial = termPosition - 150 < 0 ? 0 : termPosition - 150;
    const posFinal = termPosition + 150 > sizeText ? sizeText : termPosition + 150;

    const excerpt = this.highlightQuery(text.substring(posInitial, posFinal), cleanTerm);
    return excerpt + "...";
  }

  highlightQuery(string, term) {
    const regex = new RegExp(term, "gi");
    const match = string.match(regex);

    if (!match) {
      return string;
    }

    return string.replace(regex, (matched) => `<span class='highlightedText'>${matched}</span>`);

  }

  removeAccents(str: string): string {
    const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÑñ';
    const accentsOut = 'AAAAAAaaaaaaOOOOOOooooooEEEEeeeeCcIIIIiiiiUUUUuuuuNn';

    return str.split('').map((letter) => {
      const accentIndex = accents.indexOf(letter);
      return accentIndex !== -1 ? accentsOut[accentIndex] : letter;
    }).join('');
  }
}
